import { createContext, PropsWithChildren, useContext } from 'react'
import { ICD10GroupWithId, UseICD10Library, useICD10Library } from './hooks'

export const ICD10LibraryContext = createContext<UseICD10Library>({
  data: null,
  loading: false,
  ref: null,
  groups: [],
  handleAddCode: async () => ({ error: 'Out of ICD10LibraryContext' }),
  handleUpdateCodeDescription: async () => ({ error: 'Out of ICD10LibraryContext' }),
  handleUpdateCodeKeywords: async () => ({ error: 'Out of ICD10LibraryContext' }),
  handleUpdateCodeAutoTrigger: async () => ({ error: 'Out of ICD10LibraryContext' }),
  handleDeleteCode: async () => ({ error: 'Out of ICD10LibraryContext' }),
  handleCodeDragEnd: () => () => {},
  handleAddGroup: async () => ({ error: 'Out of ICD10LibraryContext' }),
  handleUpdateGroupName: async () => ({ error: 'Out of ICD10LibraryContext' }),
  handleDeleteGroup: async () => ({ error: 'Out of ICD10LibraryContext' }),
  handleGroupDragEnd: () => {},
})

export const useICD10LibraryContext = () => useContext(ICD10LibraryContext)

export const ICD10LibraryProvider = ({ children }: PropsWithChildren) => {
  const value = useICD10Library()
  return <ICD10LibraryContext.Provider value={value}>{children}</ICD10LibraryContext.Provider>
}

// Re-export for convenience in child components
export type { ICD10GroupWithId }
